export default __webpack_public_path__ + "static/media/sun.b05241bc.glb";